<div class="mt-4 space-y-4">
    <div class="card">
        <form [formGroup]="form" class="space-y-4">
            <div class="w-full">
                <label class="text-sm">ช่วงเวลาข้อมูล</label>
                <app-select-date-option [selectedOption]="selectedDate"
                    (selectOption)="handleOptionSelected($event)"></app-select-date-option>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div class="w-full">
                    <label class="text-sm">ช่องทางการขาย</label>
                    <mat-form-field class="w-full">
                        <mat-select multiple [value]="displayedChannelSelection"
                            (selectionChange)="onChannelSelectionChange($event.value)"
                            placeholder="เลือกช่องทางการขาย">
                            <mat-option [value]="ALL_CHANNEL_MARKER">เลือกทั้งหมด</mat-option>
                            @for (channel of channels; track $index) {
                            <mat-option [value]="channel.shop_ref">
                                {{channel.platform_name}}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="w-full md:col-span-2">
                    <label class="text-sm">สินค้า</label>
                    <div class="flex gap-2 w-full relative">
                        <input #product type="text" class="input" placeholder="SKU, ชื่อสินค้า" [(ngModel)]="keyword"
                            [ngModelOptions]="{standalone: true}" (ngModelChange)="productSearch($event)">
                        <ul class="absolute z-50 w-96 !rounded-lg bg-white mat-elevation-z8 max-h-72 overflow-y-auto top-11 py-2"
                            *ngIf="showProductFilter">
                            <li *ngFor="let product of productsFilter"
                                class="min-h-[48px] whitespace-nowrap hover:bg-secondary-100 hover:cursor-pointer flex items-center p-2 text-sm"
                                (click)="selectProduct(product)">
                                <img [src]="'https://storage.maxxgadget.com/img/product/' + product.sku + '/1.jpg'"
                                    alt="" class="flex-none h-11 w-11 mr-2"
                                    onerror="this.onerror=null; this.src='assets/images/warranty.png'">
                                <div class="w-full flex flex-col truncate">
                                    <span class="pr-2 text-blue-500">{{ product.sku }} :</span>
                                    <span class="w-full truncate whitespace-nowrap">{{ product.name }}</span>
                                </div>
                            </li>
                        </ul>
                        @if (keyword.length > 0) {
                        <div class="absolute flex justify-center flex-col right-2 top-1">
                            <button (click)="clearSearch()">
                                <fa-icon [icon]="faXmark" class="text-secondary-900"></fa-icon>
                            </button>
                        </div>
                        }
                    </div>
                </div>
                <button class="btn-sm btn-primary w-full md:w-fit self-end" [disabled]="loading"
                    (click)="submitForm()">ค้นหา</button>
            </div>
        </form>
        <div class="mt-4 w-full bg-gray-100 rounded-lg p-4 text-sm">
            <div class="flex gap-4">
                <div class="whitespace-nowrap text-gray-500">ช่องทางการขาย : </div>
                @if(channelSelected.length>0){
                <div class="w-full flex flex-row gap-1 flex-wrap">
                    @for (item of displaychannel(); track $index) {
                    <div class="label label-secondary w-fit !text-xs text-nowrap flex items-center gap-2">
                        <span class="inline-block w-2 h-2 rounded-full"
                            [style.background-color]="item.color || '#32436a'"></span>
                        {{item.platform_name}}
                        <span class="cursor-pointer ml-1" (click)="removeChannelSelected(item)">&#x2715;</span>
                    </div>
                    }
                    @if(channelSelected.length>1){
                    <button class="label label-light w-fit !text-xs text-nowrap border" type="button"
                        (click)="removeChannelSelectedAll()">ลบทั้งหมด</button>
                    }
                </div>
                }@else {
                ทั้งหมด
                }
            </div>
            <div class="flex gap-4 mt-2">
                <div class="whitespace-nowrap text-gray-500">สินค้าที่เลือก : </div>
                @if(this.productSelected.length>0){
                <div class="w-full flex flex-row gap-1 flex-wrap">
                    @for (item of productSelected; track $index) {
                    <div class="label label-primary w-fit !text-xs text-nowrap">
                        {{item.name}}
                        <span class="cursor-pointer ml-3" (click)="removeProductSelected(item)">&#x2715;</span>
                    </div>
                    }
                    @if(this.productSelected.length>1){
                    <button class="label label-light w-fit !text-xs text-nowrap border" type="button"
                        (click)="removeProductSelectedAll()">ลบทั้งหมด</button>
                    }
                </div>
                }@else {
                ทั้งหมด
                }
            </div>
        </div>
    </div>

    @if(loading){
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <app-loader></app-loader>
            <div class="font-medium">Loading</div>
        </div>
    </div>
    }
    @if (!loading && tableDatasets.length === 0) {
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <div class="h-32">
                <img src="assets/images/web_20.png" alt="" class="h-full">
            </div>
            <div class="font-medium">Data Not Found</div>
        </div>
    </div>
    }
    @else if (!loading && tableDatasets.length > 0){
    <div class="grid grid-cols-1">
        <div class="card">
            <div class="w-full">
                <div class="flex space-x-2 items-center justify-between">
                    <div class="font-medium">
                        ยอดขายสินค้า
                    </div>
                    <div class="flex space-x-2 items-center">
                        <div class="text-sm">การแสดงผล : </div>
                        <mat-form-field class="w-fit !h-9 !text-sm">
                            <mat-select class="!h-9" [value]="displayData"
                                (selectionChange)="displayDataOnchange($event)">
                                <mat-option class="!text-sm" value="total_amount">มูลค่า</mat-option>
                                <mat-option class="!text-sm" value="total_qty">จำนวนชิ้น</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="mt-4">
                <div class="div-table">
                    <div class="relative w-full h-[600px]">
                        <div class="w-full h-full overflow-auto">
                            <table class="min-w-full border-separate border-spacing-0">
                                <thead>
                                    <tr class="thead-tr">
                                        <th class="text-left sticky left-0 top-0 z-30 bg-gray-100 border-r border-gray-200 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]">
                                            สินค้า
                                        </th>
                                        @for (item of channelFiltered; track $index) {
                                        <th class="text-right sticky top-0 z-20 bg-gray-100 w-28 min-w-[7rem]">
                                            <button class="w-full text-right flex flex-row space-x-1 items-center justify-end"
                                                (click)="sortData(item.shop_ref)">
                                                <div class="">{{item.platform_name}}</div>
                                                <div class="gap-0">
                                                    @if (sortSelected===item.shop_ref && sortBy) {
                                                    <fa-icon *ngIf="sortBy==='min'" [icon]="faCaretUp"
                                                        class="text-primary-500"></fa-icon>
                                                    <fa-icon *ngIf="sortBy==='max'" [icon]="faCaretDown"
                                                        class="text-primary-500"></fa-icon>
                                                    }@else {
                                                    <fa-icon [icon]="faSort" class="text-gray-400"></fa-icon>
                                                    }
                                                </div>
                                            </button>
                                        </th>
                                        }
                                        <th class="text-right sticky right-0 top-0 z-30 bg-gray-100 border-l border-gray-200 shadow-[-2px_0_5px_-2px_rgba(0,0,0,0.1)]">
                                            <button class="w-full text-right flex flex-row space-x-1 items-center justify-end"
                                                (click)="sortData('')">
                                                <div class="">รวม</div>
                                                <div class="gap-0">
                                                    @if (sortSelected==='' && sortBy) {
                                                    <fa-icon *ngIf="sortBy==='min'" [icon]="faCaretUp"
                                                        class="text-primary-500"></fa-icon>
                                                    <fa-icon *ngIf="sortBy==='max'" [icon]="faCaretDown"
                                                        class="text-primary-500"></fa-icon>
                                                    }@else {
                                                    <fa-icon [icon]="faSort" class="text-gray-400"></fa-icon>
                                                    }
                                                </div>
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (row of tableDatasets; track row.sku) {
                                    <tr class="tbody-tr"
                                        [ngClass]="row.name === TOTAL_ROW_NAME ? 'bg-primary-50 font-bold border-t-2 border-primary-300' : 'cursor-pointer'"
                                        (click)="row.name !== TOTAL_ROW_NAME && selectedRowOnChange(row)">
                                        <td class="min-w-[20rem] max-w-[20rem] sticky left-0 z-10 border-r border-gray-200 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1),inset_0_-1px_0_0_#e5e7eb]"
                                            [ngClass]="row.name === TOTAL_ROW_NAME ? 'bg-primary-50' : 'bg-white'">
                                            <div class="flex items-center gap-2">
                                                @if(row.sku){
                                                <img [src]="'https://storage.maxxgadget.com/img/product/' + row.sku + '/1.jpg'"
                                                    alt="" class="w-8 h-8 shrink-0"
                                                    onerror="this.onerror=null; this.src='assets/images/warranty.png'">
                                                }
                                                <div class="min-w-0 flex-1">
                                                    @if (row.sku) {
                                                    <div class="text-blue-500 text-xs">{{row.sku}}</div>
                                                    }
                                                    <div class="truncate">{{row.name}}</div>
                                                    @if (row.name !== TOTAL_ROW_NAME) {
                                                    @if (branchMode) {
                                                    <button type="button"
                                                        class="space-x-1 flex items-center hover:underline"
                                                        [matMenuTriggerFor]="stockMenu"
                                                        (menuOpened)="loadStockBreakdown(row.sku)"
                                                        (click)="$event.stopPropagation()">
                                                        <span class="text-gray-400">สต๊อกรวม:</span>
                                                        <span
                                                            [ngClass]="{'text-lime-500': row.stock >0 , 'text-red-600': row.stock <= 0}">{{row.stock|
                                                            number}}</span>
                                                        <fa-icon [icon]="faCaretDown"
                                                            class="text-gray-400 text-xs"></fa-icon>
                                                    </button>
                                                    } @else {
                                                    <div class="space-x-1 flex">
                                                        <span class="text-gray-400">สต๊อกรวม:</span>
                                                        <span
                                                            [ngClass]="{'text-lime-500': row.stock >0 , 'text-red-600': row.stock <= 0}"
                                                            class="">{{row.stock| number}}</span>
                                                    </div>
                                                    }
                                                    }
                                                </div>
                                            </div>
                                        </td>
                                        @for (item of row.channels; track $index) {
                                        <td class="text-right"
                                            [ngClass]="{
                                              'text-blue-500 font-semibold': $index === row.channels.length - 1 && row.name !== TOTAL_ROW_NAME,
                                              'sticky right-0 z-10 border-l border-gray-200 shadow-[-2px_0_5px_-2px_rgba(0,0,0,0.1),inset_0_-1px_0_0_#e5e7eb]': $index === row.channels.length - 1,
                                              'bg-primary-50': $index === row.channels.length - 1 && row.name === TOTAL_ROW_NAME,
                                              'bg-white': $index === row.channels.length - 1 && row.name !== TOTAL_ROW_NAME
                                            }">
                                            @if (displayData==='total_qty') {
                                            {{item.total_qty | number}}
                                            }@else {
                                            {{item.total_amount | number}}
                                            }
                                        </td>
                                        }
                                    </tr>
                                    @if (row.name !== TOTAL_ROW_NAME) {
                                    <tr>
                                        <td colspan="100"
                                            class="transition-[max-height,opacity] ease-in-out duration-500 relative overflow-hidden"
                                            [ngClass]="{ 'max-h-96 opacity-100': selectedRow === row.sku, 'max-h-0 opacity-0 hidden': selectedRow !== row.sku }">
                                            <div class="px-4 py-8">
                                                @if(chartLoaded && performanceDatasets.length > 0){
                                                <div class="text-center font-medium py-2">ยอดขาย 30 วันย้อนหลัง</div>
                                                <div class="h-48">
                                                    <app-line-chart [chartId]="'chart-performance-'+row.sku"
                                                        [legendPosition]="legendPosition"
                                                        [colorScheme]="performanceChartScheme"
                                                        [datasets]="performanceDatasets"></app-line-chart>
                                                </div>
                                                }@else if (chartLoaded && performanceDatasets.length === 0) {
                                                <div
                                                    class="h-48 w-full flex items-center justify-center bg-gray-100 rounded-lg">
                                                    <div class="">ไม่พบข้อมูล</div>
                                                </div>
                                                }@else {
                                                <div
                                                    class="h-48 w-full flex items-center justify-center bg-gray-100 rounded-lg">
                                                    <app-loader></app-loader>
                                                </div>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                    }
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <app-pagination *ngIf="countDataSource" [callBackPageChange]="callBackPageChange" [pageSize]="pageSize"
                    [pageIndex]="pageIndex" [length]="countDataSource"></app-pagination>
            </div>
        </div>
    </div>
    }

    <mat-menu #stockMenu="matMenu" xPosition="after" yPosition="below">
        <ng-template matMenuContent>
            <div class="w-56 py-2 text-sm" (click)="$event.stopPropagation()">
                <div class="px-3 pb-2 text-xs text-gray-400 border-b border-gray-100">สต๊อกตามช่องทาง</div>
                @if (breakdownLoading) {
                <div class="flex justify-center py-3">
                    <app-loader></app-loader>
                </div>
                } @else if (breakdownItems.length === 0) {
                <div class="px-3 py-2 text-gray-400">ไม่พบข้อมูล</div>
                } @else {
                @for (item of breakdownItems; track $index) {
                <div class="px-3 py-1 flex items-center justify-between gap-3">
                    <div class="flex items-center gap-2 truncate">
                        <span class="inline-block w-2 h-2 rounded-full shrink-0"
                            [style.background-color]="item.color || '#32436a'"></span>
                        <span class="truncate">{{item.platform_name}}</span>
                    </div>
                    <span
                        [ngClass]="{'text-lime-500': item.sellable>0, 'text-red-600': item.sellable<=0}">{{item.sellable
                        | number}}</span>
                </div>
                }
                }
            </div>
        </ng-template>
    </mat-menu>
</div>